// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let MlsPlanDate = require("../../common/MlsPlanDate.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan_graphql = require("../../../__generated__/PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Preview__Sidecard__MlsInfo$DateBlock(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.title,
        className: "text-gray-500 uppercase font-medium tracking-wide"
      }),
      JsxRuntime.jsx("div", {
        children: MlsPlanDate.formatDate(props.date),
        className: "text-lg font-medium"
      })
    ],
    className: "space-y-2"
  });
}

let DateBlock = {
  make: PropertyWizardRelay__Preview__Sidecard__MlsInfo$DateBlock
};

function booleanLabel(value, whenTrue, whenFalse) {
  if (value !== undefined) {
    if (value) {
      return Primitive_option.some(whenTrue);
    } else {
      return Primitive_option.some(whenFalse);
    }
  }
}

function PropertyWizardRelay__Preview__Sidecard__MlsInfo$BulletList(props) {
  let items = props.items;
  let match = items.length;
  if (match !== 0) {
    return JsxRuntime.jsx("ul", {
      children: items.map((item, index) => JsxRuntime.jsxs("li", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "bullet",
              className: "text-zinc-400"
            }),
            className: "-mb-2 mr-2"
          }),
          item
        ],
        className: "flex flex-row space-x-2 font-medium"
      }, index.toString())),
      className: "mt-2 space-y-3"
    });
  } else {
    return null;
  }
}

let BulletList = {
  make: PropertyWizardRelay__Preview__Sidecard__MlsInfo$BulletList
};

function PropertyWizardRelay__Preview__Sidecard__MlsInfo(props) {
  let mlsPlan = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewSidecardMlsInfo_mlsPlan_graphql.node, convertFragment, props.mlsPlan);
  let className = Stdlib_Option.getOr(props.className, "");
  if (props.propertyType === "FOR_SALE") {
    let match;
    switch (mlsPlan.__typename) {
      case "ListOnMlsAsActive" :
        match = [
          Primitive_option.some(mlsPlan.onMlsAt),
          mlsPlan.willShowPriorToMls,
          mlsPlan.willAcceptOffersPriorToMls
        ];
        break;
      case "ListOnMlsAsComingSoon" :
        match = [
          Primitive_option.some(mlsPlan.activeOnMlsOn),
          mlsPlan.willShowPriorToMls,
          mlsPlan.willAcceptOffersPriorToMls
        ];
        break;
      case "NoMlsPlan" :
        match = [
          undefined,
          mlsPlan.willShow,
          mlsPlan.willAcceptOffers
        ];
        break;
      case "__unselected" :
        match = UnselectedUnionMemberError.raise(`Unselected PropertyWizardRelayPreviewSidecardMlsInfo ` + mlsPlan._0);
        break;
    }
    let onMlsAt = match[0];
    let items = Stdlib_Array.keepSome([
      booleanLabel(match[1], "Will show before MLS", "Won't show before MLS"),
      booleanLabel(match[2], "Will accept offers before MLS", "Won't accept offers before MLS")
    ]);
    let match$1 = items.length;
    if (onMlsAt === undefined && match$1 === 0) {
      return null;
    }
    return JsxRuntime.jsxs("div", {
      children: [
        onMlsAt !== undefined ? JsxRuntime.jsx(PropertyWizardRelay__Preview__Sidecard__MlsInfo$DateBlock, {
            title: "Expected on MLS",
            date: Primitive_option.valFromOption(onMlsAt)
          }) : null,
        JsxRuntime.jsx(PropertyWizardRelay__Preview__Sidecard__MlsInfo$BulletList, {
          items: items
        })
      ],
      className: TailwindMerge.twMerge([
        "space-y-4",
        className
      ])
    });
  }
  let onMlsAt$1;
  switch (mlsPlan.__typename) {
    case "ListOnMlsAsActive" :
      onMlsAt$1 = mlsPlan.onMlsAt;
      break;
    case "ListOnMlsAsComingSoon" :
      onMlsAt$1 = mlsPlan.activeOnMlsOn;
      break;
    case "NoMlsPlan" :
    case "__unselected" :
      return null;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(PropertyWizardRelay__Preview__Sidecard__MlsInfo$DateBlock, {
      title: "On MLS",
      date: onMlsAt$1
    }),
    className: className
  });
}

let make = PropertyWizardRelay__Preview__Sidecard__MlsInfo;

exports.Fragment = Fragment;
exports.DateBlock = DateBlock;
exports.booleanLabel = booleanLabel;
exports.BulletList = BulletList;
exports.make = make;
/* IconV5 Not a pure module */
